export default __webpack_public_path__ + "static/media/resume.4fb6f9de.pdf";